import React, { FunctionComponent, useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { Grid2, Stack, Typography } from '@mui/material';
import { IAlertProps } from '../../interface/IAlertProps';
import { generateUserIdMemmory, getDefaultAlertProps } from '../../utils/utils';
import { MyAlert } from '../UI/MyAlert';
import { MyButton } from '../UI/MyButton';
import { PutchaseDivItem } from './PurchaseDivItem';
import { PurchaseDto } from '../../dto/PurchaseDto';
import { IApiResult } from '../../interface/IApiResult';
import { apiPay } from '../../service/apiPay';
import { API_STATUS_PROBLEM } from '../../constant/constants';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import classes from './PurchaseDiv.module.css';
import Skeleton from '../../image/webp_SkeletonCons.webp';
import { BackDropDiv } from '../backdrop/BackDropDiv';
import { apiPayMemmory } from '../../service/apiPayMemmory';

const HARDCODED_DATA: PurchaseDto[] = [
  {
    id: 'anatomy',
    route: 'anatomy',
    name: 'Анатомия',
    subtitle: '3D и 2D',
    cenaMonth: 540,
    cenaYear: 3240,
  },
  {
    id: 'histology',
    route: 'histology',
    name: 'Гистология',
    subtitle: '',
    cenaMonth: 360,
    cenaYear: 2160,
  },
  {
    id: 'biochemistry',
    route: 'biochemistry',
    name: 'Биохимия',
    subtitle: '',
    cenaMonth: 360,
    cenaYear: 2160,
  },
  {
    id: 'physiology',
    route: 'physiology',
    name: 'Физиология',
    subtitle: '',
    cenaMonth: 360,
    cenaYear: 2160,
  },
];

const getPurchaseId = (route: string, isYear: boolean) => {
  if (!isYear) {
    if (route === 'anatomy') {
      return 'com.learnanat.fullaccess';
    }
    if (route === 'histology') {
      return 'com.learnmed.histology.fullaccess';
    }
    if (route === 'biochemistry') {
      return 'com.learnmed.biochemistry.fullaccess';
    }
    if (route === 'physiology') {
      return 'com.learnmed.physiology.fullaccess';
    }
  }
  if (isYear) {
    if (route === 'anatomy') {
      return 'com.learnanat.fullaccess.year';
    }
    if (route === 'histology') {
      return 'com.learnmed.histology.fullaccess.year';
    }
    if (route === 'biochemistry') {
      return 'com.learnmed.biochemistry.fullaccess.year';
    }
    if (route === 'physiology') {
      return 'com.learnmed.physiology.fullaccess.year';
    }
  }

  return '';
};

interface Props {
  onChange: (e: any) => void;
  isLending?: boolean;
  height?: string;
  shopId?: string;
  constHeight?: number;
}

export const PurchaseDiv: FunctionComponent<Props> = ({
  onChange,
  isLending,
  height,
  shopId,
  constHeight,
}) => {
  const [price, setPrice] = useState(0);
  const [isRoute, setIsRoute] = useState(false);
  const [priceWithout, setPriceWithout] = useState(0);
  const [priceYear, setPriceYear] = useState(0);
  const [priceYearWithout, setPriceYearWithout] = useState(0);
  const [startAnimation, setSatrtAnimation] = useState(false);
  const [disc, setDiscount] = useState(0);

  const [predmetArray, setPredmetArray] = useState<string[]>([]);
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );

  const [json, setJson] = useState<PurchaseDto[]>(HARDCODED_DATA);

  const [visible, setVisible] = useState(false);

  const showToast = (duration = 2000) => {
    setVisible(true);
    setTimeout(() => setVisible(false), duration);
  };

  const [email, setEmail] = useState('');

  const [open, setOpen] = React.useState(false);
  const [backdrop, setOpenBackdrop] = useState(false);
  const [priceToPayMemmory, setPriceToPayMemmory] = useState(0);
  const [isYearMemmory, setIsYearMemmory] = useState(false);
  const handleOpen = (priceToPay: number, isYear: boolean) => {
    setPriceToPayMemmory(priceToPay);
    setIsYearMemmory(isYear);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const addPredmet = (item: any) => {
    setSatrtAnimation(true);
    let arraypredmet = predmetArray;

    let discount = 0;
    if (arraypredmet.length > 1) {
      if (arraypredmet.length === 2) {
        discount = 25;
      }
      if (arraypredmet.length === 3) {
        discount = 35;
      }
      if (arraypredmet.length === 4) {
        discount = 50;
      }
    }

    let cenaall = (price * 100) / (100 - discount);
    let cenaallYear = (priceYear * 100) / (100 - discount);

    let cenaallWithout = 0;
    let cenaallYearWithout = 0;

    if (arraypredmet.indexOf(item.route) > -1) {
      const newAr = [];
      for (let i = 0; i < arraypredmet.length; i += 1) {
        if (arraypredmet[i] !== item.route) {
          newAr.push(arraypredmet[i]);
        }
      }
      arraypredmet = newAr;
      cenaall -= item.cenaMonth;
      cenaallYear -= item.cenaYear;
    } else {
      arraypredmet.push(item.route);
      cenaall += item.cenaMonth;
      cenaallYear += item.cenaYear;
    }

    discount = 0;
    if (arraypredmet.length > 1) {
      if (arraypredmet.length === 2) {
        discount = 25;
      }
      if (arraypredmet.length === 3) {
        discount = 35;
      }
      if (arraypredmet.length === 4) {
        discount = 50;
      }
    }
    setDiscount(discount);
    cenaallWithout = cenaall;
    cenaallYearWithout = cenaallYear;
    cenaall = (cenaall * (100 - discount)) / 100;
    cenaallYear = (cenaallYear * (100 - discount)) / 100;

    setPredmetArray(arraypredmet);

    setPrice(cenaall);
    setPriceYear(cenaallYear);
    setPriceWithout(cenaallWithout);
    setPriceYearWithout(cenaallYearWithout);
  };

  const { userId } = useParams();

  const [variant, setVariant] = useState(0);

  const savePaymentTokenServer = async (
    idMem: string,
    pidMem: string,
    priceMem: number
  ) => {
    const apiResult: IApiResult = await apiPayMemmory(idMem, pidMem, priceMem);
    if (apiResult.isSuccess) {
      window.location.replace(
        `com.learnanat://pair_device?id=lending&shop_id=${idMem}`
      );
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
  };

  /*
   const savePaymentTokenServer = async (
      idMem: string,
      pidMem: string,
      priceMem: number
    ) => {
      const apiResult: IApiResult = await apiPayMemmory(idMem, pidMem, priceMem);
      if (apiResult.isSuccess) {
        const isAndroid = /Android/i.test(navigator.userAgent);
        const isIOS = /iPad|iPhone|iPod/i.test(navigator.userAgent);
        const isHuawei = /Huawei|HUAWEI/i.test(navigator.userAgent);
        const isHarmonyOS = /HarmonyOS/i.test(navigator.userAgent);
  
        const path = `pair_device?id=lending&shop_id=${idMem}`;
  
        // Huawei (отдельное приложение в AppGallery)
        if (isHuawei || isHarmonyOS) {
          const packageName = 'com.learnanat.huawei';
          const scheme = 'com.learnanat.huawei';
          const intentUrl = `intent://${path}#Intent;scheme=${scheme};package=${packageName};end;`;
          window.location.href = intentUrl;
        }
        // Обычный Android
        else if (isAndroid) {
          const intentUrl = `intent://${path}#Intent;scheme=com.learnanat;package=com.learnanat;end;`;
          window.location.href = intentUrl;
        }
        // iOS
        else if (isIOS) {
          const url = `com.learnanat://${path}`;
          window.location.href = url;
        } else {
          window.location.href = `com.learnanat://${path}`;
        }
      } else {
        setAlertProps({
          message: API_STATUS_PROBLEM,
          severity: AlertSeverityEnum.error,
        });
      }
    };
  */

  const getPayDto = async (priceToPay: number, isYear: boolean) => {
    if (email === '' && isLending) {
      return;
    }

    if (priceToPay === 0) {
      showToast();
      return;
    }

    onChange(1);

    let preadmetString = '';
    for (let i = 0; i < predmetArray.length; i += 1) {
      preadmetString = `${preadmetString}${getPurchaseId(
        predmetArray[i],
        isYear
      )};`;
    }
    if (preadmetString !== '') {
      preadmetString = preadmetString.substring(0, preadmetString.length - 1);

      if ((userId === undefined || isRoute) && !isLending) {
        // onChange(0);
        await savePaymentTokenServer(
          generateUserIdMemmory(),
          preadmetString,
          priceToPay
        );
        return;
      }
      setOpenBackdrop(true);
      const apiResult: IApiResult = await apiPay(
        !isLending ? userId ?? '' : shopId ?? '',
        preadmetString,
        priceToPay,
        email,
        isLending ? 1 : 0
      );

      if (apiResult.isSuccess) {
        window.location.replace(apiResult.data.url);
      } else {
        setAlertProps({
          message: API_STATUS_PROBLEM,
          severity: AlertSeverityEnum.error,
        });
      }
      setOpenBackdrop(false);
    }
  };

  const getSizePictureFona = () => {
    let widtn = window.innerWidth;
    let heghh = window.innerHeight;
    if (isLending) {
      heghh = constHeight ?? 0;
    }
    if (widtn > 1270) {
      widtn = 1270;
    }
    if (heghh > 1624) {
      heghh = 1624;
    }
    widtn = (heghh * 1270) / 1624;
    return `${widtn}px ${heghh}px`;
  };

  useEffect(() => {
    if (userId !== undefined) {
      for (let i = 0; i < HARDCODED_DATA.length; i += 1) {
        if (userId === HARDCODED_DATA[i].route) {
          addPredmet(HARDCODED_DATA[i]);
          setIsRoute(true);
        }
      }
    }
    // getPrice();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack
      height={!isLending ? '100%' : height}
      width="100%"
      alignItems="center"
      justifyContent={!isLending ? 'space-between' : undefined}
      sx={{
        background: '#1D2228',
        backgroundImage: !isLending ? `url(${Skeleton})` : undefined,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center top',
        backgroundSize: `${getSizePictureFona()}`,
      }}
    >
      <MyAlert
        message={alertProps.message}
        severity={alertProps.severity}
        onClose={() => setAlertProps({ ...alertProps, message: '' })}
      />
      <BackDropDiv open={backdrop} />
      <Stack>
        <Typography
          fontWeight={700}
          fontFamily="Comfortaa"
          lineHeight="100%"
          fontSize="20px"
          letterSpacing="0.26px"
          paddingTop="20px"
          textAlign="center"
          color="#FFFFFF"
          component="text"
        >
          Собери подписку
        </Typography>
        {price === 0 && (
          <Typography
            fontWeight={700}
            fontFamily="Roboto"
            lineHeight="100%"
            fontSize="12px"
            letterSpacing="0.21px"
            paddingTop="5px"
            textAlign="center"
            color="#00C7D3"
            component="text"
          >
            Выберите предметы
          </Typography>
        )}
        {price !== 0 && (
          <Stack direction="row" spacing={0.5}>
            <Typography
              fontWeight={400}
              fontFamily="Roboto"
              lineHeight="100%"
              fontSize="12px"
              letterSpacing="0.21px"
              paddingTop="5px"
              textAlign="center"
              color="#00C7D3"
              component="text"
            >
              Чем больше предметов, тем
            </Typography>
            <Typography
              fontWeight={700}
              fontFamily="Roboto"
              lineHeight="100%"
              fontSize="12px"
              letterSpacing="0.21px"
              paddingTop="5px"
              textAlign="center"
              color="#00C7D3"
              component="text"
            >
              выше скидка
            </Typography>
          </Stack>
        )}
      </Stack>
      <Stack paddingTop="10px" width="335px">
        <Grid2 container spacing={1}>
          {json.map((item) => (
            <Grid2 size={12}>
              <PutchaseDivItem
                discount={disc}
                variant={variant}
                dto={item}
                isSelect={predmetArray.indexOf(item.route) > -1}
                onClick={() => addPredmet(item)}
              />
            </Grid2>
          ))}
        </Grid2>

        <Stack
          visibility={price === 0 ? 'hidden' : 'visible'}
          paddingTop="10px"
          direction="row"
          alignItems="center"
          paddingLeft="10px"
          paddingRight="10px"
          justifyContent="space-between"
        >
          {disc === 0 && (
            <Stack direction="row" alignItems="center" spacing={0.5}>
              <Typography
                fontWeight={400}
                fontFamily="Roboto"
                lineHeight="100%"
                fontSize="12px"
                letterSpacing="0.21px"
                textAlign="center"
                color="#00C7D3"
                component="text"
              >
                Больше предметов
              </Typography>
              <Typography
                fontWeight={700}
                fontFamily="Roboto"
                lineHeight="100%"
                fontSize="12px"
                letterSpacing="0.21px"
                textAlign="center"
                color="#00C7D3"
                component="text"
              >
                ‣ выше скидка
              </Typography>
            </Stack>
          )}
          {disc !== 0 && (
            <Typography
              fontWeight={700}
              fontFamily="Roboto"
              lineHeight="100%"
              fontSize="14px"
              letterSpacing="0.21px"
              textAlign="left"
              color="#00C7D3"
              component="text"
            >
              {disc !== 0 ? `Скидка ${disc} %` : ``}
            </Typography>
          )}
          <Typography
            fontWeight={700}
            fontFamily="Roboto"
            lineHeight="100%"
            fontSize="14px"
            letterSpacing="0.21px"
            textAlign="right"
            color="#FFFFFF"
            component="text"
          >
            {predmetArray.length}
            {predmetArray.length === 1 ? ' ПРЕДМЕТ' : ' ПРЕДМЕТА'}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        paddingTop={isLending ? '20px' : undefined}
        paddingBottom="10px"
        width="335px"
        spacing={1}
      >
        <Stack
          visibility={price !== 0 || visible ? 'hidden' : 'visible'}
          direction="row"
          width="335px"
          alignItems="center"
          justifyContent="center"
          spacing={0.5}
        >
          <Typography
            fontWeight={400}
            fontFamily="Roboto"
            lineHeight="100%"
            fontSize="12px"
            letterSpacing="0.21px"
            paddingTop="5px"
            textAlign="center"
            color="#FFFFFF"
            component="text"
          >
            Чем больше предметов, тем
          </Typography>
          <Typography
            fontWeight={700}
            fontFamily="Roboto"
            lineHeight="100%"
            fontSize="12px"
            letterSpacing="0.21px"
            paddingTop="5px"
            textAlign="center"
            color="#FFFFFF"
            component="text"
          >
            выше скидка
          </Typography>
        </Stack>

        <Stack
          sx={{
            filter:
              price === 0
                ? 'drop-shadow(0 0 12px #FFFFFF33)'
                : 'drop-shadow(0 0 30px #3478F6)',
          }}
        >
          <Stack>
            <MyButton
              text={
                <Stack
                  alignItems="center"
                  direction="row"
                  width="100%"
                  justifyContent="space-between"
                >
                  <Typography
                    width="100px"
                    fontWeight={700}
                    fontFamily="Roboto"
                    lineHeight="100%"
                    fontSize="14px"
                    letterSpacing="0.21px"
                    textAlign="left"
                    color="#FFFFFF"
                    component="text"
                  >
                    ОФОРМИТЬ
                  </Typography>
                  <Typography
                    fontWeight={400}
                    fontFamily="Roboto"
                    lineHeight="100%"
                    fontSize="12px"
                    letterSpacing="0.21px"
                    textAlign="center"
                    color="#FFFFFF80"
                    component="text"
                  >
                    12 месяцев
                  </Typography>
                  {price !== 0 && (
                    <Stack
                      direction="column"
                      width="100px"
                      spacing={0.5}
                      justifyContent="right"
                    >
                      {disc > 0 && variant === 1 && (
                        <Stack
                          direction="row"
                          justifyContent="right"
                          alignItems="end"
                          spacing={0}
                        >
                          <Typography
                            fontWeight={400}
                            fontFamily="Roboto"
                            lineHeight="100%"
                            fontSize="16x"
                            letterSpacing="0.21px"
                            textAlign="center"
                            color="#FFFFFF80"
                            component="text"
                            style={{
                              textDecoration: 'line-through',
                            }}
                          >
                            {`${Math.floor(priceYearWithout)} ₽`}
                          </Typography>
                          <Typography
                            fontWeight={400}
                            fontFamily="Roboto"
                            lineHeight="100%"
                            fontSize="10px"
                            letterSpacing="0.21px"
                            textAlign="center"
                            color="#FFFFFF80"
                            component="text"
                          >
                            /год
                          </Typography>
                        </Stack>
                      )}
                      {variant === 10 && (
                        <Stack
                          direction="row"
                          justifyContent="right"
                          alignItems="end"
                          spacing={0}
                        >
                          <Typography
                            fontWeight={400}
                            fontFamily="Roboto"
                            lineHeight="100%"
                            fontSize="16x"
                            letterSpacing="0.21px"
                            textAlign="center"
                            color="#FFFFFF80"
                            component="text"
                            style={{
                              textDecoration: 'line-through',
                            }}
                          >
                            {`${Math.floor(priceWithout * 12)} ₽`}
                          </Typography>
                          <Typography
                            fontWeight={400}
                            fontFamily="Roboto"
                            lineHeight="100%"
                            fontSize="10px"
                            letterSpacing="0.21px"
                            textAlign="center"
                            color="#FFFFFF80"
                            component="text"
                          >
                            /год
                          </Typography>
                        </Stack>
                      )}
                      <Stack
                        direction="row"
                        justifyContent="right"
                        alignItems="end"
                        spacing={0}
                      >
                        <Typography
                          fontWeight={700}
                          fontFamily="Roboto"
                          lineHeight="100%"
                          fontSize="16px"
                          letterSpacing="0.21px"
                          textAlign="center"
                          color="#FFFFFF"
                          component="text"
                          onAnimationEnd={() => setSatrtAnimation(false)}
                          className={startAnimation ? classes.divShake : ''}
                        >
                          {`${Math.floor(priceYear)} ₽`}
                        </Typography>
                        <Typography
                          fontWeight={400}
                          fontFamily="Roboto"
                          lineHeight="100%"
                          fontSize="10px"
                          letterSpacing="0.21px"
                          textAlign="center"
                          color="#FFFFFF80"
                          component="text"
                        >
                          /год
                        </Typography>
                      </Stack>
                      {variant === 0 && (
                        <Stack
                          direction="row"
                          justifyContent="right"
                          alignItems="end"
                          spacing={0}
                        >
                          <Typography
                            fontWeight={700}
                            fontFamily="Roboto"
                            lineHeight="100%"
                            fontSize="12px"
                            letterSpacing="0.21px"
                            textAlign="center"
                            color="#FFFFFF80"
                            component="text"
                          >
                            ~{`${Math.floor(priceYear / 12)} ₽`}
                          </Typography>
                          <Typography
                            fontWeight={400}
                            fontFamily="Roboto"
                            lineHeight="100%"
                            fontSize="10px"
                            letterSpacing="0.21px"
                            textAlign="center"
                            color="#FFFFFF80"
                            component="text"
                          >
                            /мес
                          </Typography>
                        </Stack>
                      )}
                    </Stack>
                  )}
                </Stack>
              }
              background={price === 0 ? '#FFFFFF33' : '#3478F6'}
              color="#FFFFFF"
              borderRadius="20px"
              width="335px"
              height="79px"
              onClick={() =>
                !isLending
                  ? getPayDto(Math.floor(priceYear), true)
                  : handleOpen(Math.floor(priceYear), true)
              }
            />
          </Stack>
        </Stack>
        <Stack
          sx={{
            backdropFilter: 'blur(6px)',
            WebkitBackdropFilter: 'blur(6px)',
            borderRadius: '20px',
            filter: 'drop-shadow(0 0 12px #FFFFFF33)',
          }}
        >
          <Stack>
            <MyButton
              text={
                <Stack
                  alignItems="center"
                  direction="row"
                  width="100%"
                  justifyContent="space-between"
                >
                  <Typography
                    width="100px"
                    fontWeight={700}
                    fontFamily="Roboto"
                    lineHeight="100%"
                    fontSize="14px"
                    letterSpacing="0.21px"
                    textAlign="left"
                    color="#FFFFFF"
                    component="text"
                  >
                    ОФОРМИТЬ
                  </Typography>
                  <Typography
                    fontWeight={400}
                    fontFamily="Roboto"
                    lineHeight="100%"
                    fontSize="12px"
                    letterSpacing="0.21px"
                    textAlign="center"
                    color="#FFFFFF80"
                    component="text"
                  >
                    Раз в месяц
                  </Typography>
                  {price !== 0 && (
                    <Stack
                      direction="column"
                      width="100px"
                      spacing={0.5}
                      justifyContent="right"
                    >
                      {disc > 0 && variant !== 10 && (
                        <Stack
                          direction="row"
                          justifyContent="right"
                          alignItems="end"
                          spacing={0}
                        >
                          <Typography
                            fontWeight={700}
                            fontFamily="Roboto"
                            lineHeight="100%"
                            fontSize="12px"
                            letterSpacing="0.21px"
                            textAlign="center"
                            color="#FFFFFF80"
                            component="text"
                            style={{
                              textDecoration: 'line-through',
                            }}
                          >
                            {`${Math.floor(priceWithout)} ₽`}
                          </Typography>
                          <Typography
                            fontWeight={400}
                            fontFamily="Roboto"
                            lineHeight="100%"
                            fontSize="10px"
                            letterSpacing="0.21px"
                            textAlign="center"
                            opacity="50%"
                            color="#FFFFFF80"
                            component="text"
                          >
                            /мес
                          </Typography>
                        </Stack>
                      )}
                      <Stack
                        direction="row"
                        justifyContent="right"
                        alignItems="end"
                        spacing={0}
                      >
                        <Typography
                          fontWeight={700}
                          fontFamily="Roboto"
                          lineHeight="100%"
                          fontSize="16px"
                          letterSpacing="0.21px"
                          textAlign="center"
                          color="#FFFFFF"
                          component="text"
                          onAnimationEnd={() => setSatrtAnimation(false)}
                          className={startAnimation ? classes.divShake : ''}
                        >
                          {`${Math.floor(price)} ₽`}
                        </Typography>
                        <Typography
                          fontWeight={400}
                          fontFamily="Roboto"
                          lineHeight="100%"
                          fontSize="10px"
                          letterSpacing="0.21px"
                          textAlign="center"
                          opacity="50%"
                          color="#FFFFFF80"
                          component="text"
                        >
                          /мес
                        </Typography>
                      </Stack>
                    </Stack>
                  )}
                </Stack>
              }
              background="#FFFFFF33"
              color="#FFFFFF"
              borderRadius="20px"
              width="335px"
              height="60px"
              onClick={() =>
                !isLending
                  ? getPayDto(Math.floor(price), false)
                  : handleOpen(Math.floor(price), false)
              }
            />
          </Stack>
        </Stack>

        <Typography
          visibility={price === 0 ? 'hidden' : 'visible'}
          fontWeight="regular"
          fontFamily="Roboto"
          lineHeight="16px"
          fontSize="9px"
          letterSpacing="0.15px"
          textAlign="center"
          color="#FFFFFF"
          textDecoration="none"
          component="text"
        >
          Нажимая оплатить, вы соглашаетесь с{' '}
          <a
            href="https://uchi-med.ru/offer.html"
            target="_blank"
            rel="noreferrer"
            style={{
              textDecoration: 'Underline ', // Убираем подчеркивание по умолчанию
              color: 'inherit', // Наследует цвет от родителя
              cursor: 'pointer', // Курсор-указатель при наведении
            }}
          >
            условиями публичной оферты
          </a>
        </Typography>
      </Stack>

      {visible && (
        <div
          style={{
            position: 'fixed',
            bottom: '195px',
            textAlign: 'center',
            backgroundColor: '#3478F6',
            color: '#fff',
            padding: '10px',
            borderRadius: '8px',
            zIndex: 1000,
            animation: 'fadeInUp 0.3s ease',
          }}
        >
          <Typography
            fontWeight={400}
            fontFamily="Roboto"
            lineHeight="100%"
            fontSize="14px"
            letterSpacing="0.21px"
            paddingTop="5px"
            textAlign="center"
            color="#FFFFFF"
            component="text"
          >
            Сначала выберите предмет
          </Typography>
          <style>{`
            @keyframes fadeInUp {
              from {
                opacity: 0;
                transform: translateY(20px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }
          `}</style>
        </div>
      )}
    </Stack>
  );
};

PurchaseDiv.defaultProps = {
  isLending: false,
  height: '',
  shopId: '',
  constHeight: 0,
};
